const times = (n, func = i => i) => Array.from({ length: n }).map((_, i) => func(i));

export const getDeviceProps = () => {
  if (navigator.userAgent === 'node.js')
    return {
      model: '',
      osName: '',
      deviceType: '',
    };

  let deviceType = 'desktop';
  let model = 'Desktop';
  let osName = 'Other';
  const ua = navigator.userAgent;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua.toLowerCase())) {
    model = 'Tablet';
    deviceType = 'tablet';
  } else if (
    /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
      ua,
    )
  ) {
    model = 'Mobile phone';
    deviceType = 'mobile';
  }

  if (navigator.appVersion.indexOf('Win') !== -1) osName = 'Windows';
  if (navigator.appVersion.indexOf('iPhone') !== -1) osName = 'iOS';
  if (navigator.appVersion.indexOf('Android') !== -1) osName = 'Android';

  return { model, osName, deviceType };
};

export default times;
